import React from 'react';
import { StyledConfigurationContainer, StyledIndexContainerDiv, StyledLeadContainer } from '../../Components/Styled';
import { privateRoutesPath } from '../../Routes';
import DataGridTable from '../../Components/DataGrid';
import { Button, Tooltip, Typography, Box, Stack } from '@mui/material';
import tableBodyicon from '../../Assets/images/tablebody_edit.png'
import tableEditicon from '../../Assets/images/tableheader_edit.png';
import disabledEdit from '../../Assets/images/disabled_edit.png';
import { useDispatch, useSelector }from 'react-redux';
import { GridRowModes,GridActionsCellItem } from '@mui/x-data-grid';
import { fullNameWidth, handleValidateCodevalue, productTypeWidth, searchEntity, statusWidth, templateSubjectWidth, whocolumnWidth,  } from '../../Utility/constant';
import { requestGetTemplate } from '../../Store/Template/action';
import BiztantuSearch from '../../Components/BiztantuSearch';
import SearchTemplate from './SearchTemplate';
import moment from 'moment';
import BiztantuLoader from '../../Components/Loader';
import { resetState } from '../../Utility/resetSearchFunction';
import './template.css';

import { resetSearch, setSearch } from '../../Store/SearchReducer/action';
import { useEntitySearch } from '../../Utility/hooks/useEntitySearch';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import useNavigation from '../../Utility/hooks/useNavigation';


const TemplatesTab = () => {
    const internationalise = useSelector(state => state?.internationalise?.currentHashMapData)
    const isLoadingprogress = useSelector(state => state.global.isLoading); 
    const [rowModesModel, setRowModesModel] = React.useState({});
    const [selectionModel, setSelectionModel] = React.useState([]);
    const specificRolePermission = useSelector(state => state?.owner?.rolebasedData);
    const dispatch = useDispatch();
    const templateData  = useSelector(state => state?.template?.template);

    const { navigateTo } = useNavigation();
    const handleEditcampaign = (id) => () => {
        navigateTo(`${privateRoutesPath?.EDIT_TEMPLATE}/${id}`,{},searchEntity?.template);
    }


  const preserveSearch = useSelector(
    state => state?.search?.preserveSearch?.[searchEntity?.template]
  );
  const templateSearch = useSelector((state) => state?.search?.template) || {};
       useEntitySearch({
           entity: searchEntity?.template,
           searchState: templateSearch,
           isReady : true,
           preserveSearch,
           fetchAction: (params) =>
               requestGetTemplate(`${process.env.REACT_APP_NODE_NOTIFICATION}/get-all-notification`,
                {
                   params,
               }),
       });

    const handleSearchTemplate = async() => {
  const url = `${process.env.REACT_APP_NODE_NOTIFICATION}/get-all-notification`;
  const queryparams = {
            params: {
              ...templateSearch,
            }
          }

  await dispatch(requestGetTemplate(url,queryparams))
}


    const columns = [
      
        {
          field: 'actions',
          type: 'actions',
          headerName: <Tooltip title={handleValidateCodevalue(internationalise,'COMMON_ACTION')} ><img src={tableEditicon} className="template-edit-icon" /></Tooltip>,
          width: 100,
          cellClassName: 'actions',
          getActions: ({ id ,row}) => {
            const isInEditMode = rowModesModel[id]?.mode === GridRowModes.Edit;
    
            if (isInEditMode) {
            //   return [
            //     <GridActionsCellItem
            //       icon={<CheckIcon />}
            //       label="Save"
            //       className="textPrimary"
            //       onClick={handleSaveClick(id)}
            //     />,
            //     <GridActionsCellItem
            //       icon={<CancelIcon />}
            //       label="Cancel"
            //       className="textPrimary"
            //       onClick={handleCancelClick(id)}
            //       color="inherit"
            //     />,
            //   ];
            }
    const isSystemTemplate = row?.systemTemplateFlag === "COMMON_YES";
            return [
            //   <GridActionsCellItem
            //     icon={<EditIcon />}
            //     label="Edit"
            //     // className="textPrimary"
            //     onClick={handleEditClick(id)}
            //     color="inherit"
            //     disabled={!specificRolePermission?.isProductManage}
            //   />,
              <GridActionsCellItem
                icon={<img src={(!specificRolePermission?.isTemplateManage || isSystemTemplate) ? disabledEdit : tableBodyicon} />}
                label={ handleValidateCodevalue(internationalise,'COMMON_EDIT')}
                // className="textPrimary"
                onClick={handleEditcampaign(id)}
                color="inherit"
                disabled={!specificRolePermission?.isTemplateManage || isSystemTemplate}
              
              />,
            ];
          },
        },
        { 
          field: 'name', 
          headerName: handleValidateCodevalue(internationalise,'TEMP_SEARCH_NAME'),
          flex: 1,
          editable: false ,
          minWidth : fullNameWidth,
        },
        { 
          field: 'systemTemplateFlag', 
          headerName: handleValidateCodevalue(internationalise,'TEMP_SEARCH_EDITABLE'),
          flex: 1,
            minWidth : 150,
          editable: false ,
          valueGetter:({value})=>{
            if (value === null || value === undefined) {
              return ""
            }
            return handleValidateCodevalue(internationalise,value)
          }
        },
        { 
            field: 'subject', 
            headerName:  handleValidateCodevalue(internationalise,'TEMP_SEARCH_SUBJECT'),
            flex: 1,
            minWidth : templateSubjectWidth,
            editable: false ,
        },

        { 
          field: 'status', 
          headerName:  handleValidateCodevalue(internationalise,'TEMP_SEARCH_STATUS'),
          flex: 1,
          minWidth : statusWidth,
          editable: false ,
          valueGetter:({value})=>{
            if(!value){
              return ""
            }
            return handleValidateCodevalue(internationalise,value)
          }
        },
        { 
          field: 'type', 
          headerName:  handleValidateCodevalue(internationalise,'TEMP_SEARCH_TYPE'),
          flex: 1,
          minWidth : productTypeWidth,
          editable: false ,
          valueGetter:({value})=>{
            if(!value){
              return ""
            }
            return handleValidateCodevalue(internationalise,value)
          }
        },
        { 
          field: 'channel', 
          headerName: handleValidateCodevalue(internationalise,'TEMP_SEARCH_CHANNEL'),
          flex: 1,
          minWidth : statusWidth,
          editable: false ,
          valueGetter:({value})=>{
            if(!value){
              return ""
            }
            return handleValidateCodevalue(internationalise,value)
          }
        },
        {
          field: 'createdAt',
          headerName: handleValidateCodevalue(internationalise, 'COMMON_CREATED_AT'),
          type: 'date',
          minWidth: whocolumnWidth,
          flex: 1,
          editable: false,
          valueGetter: ({ value }) => value && moment(value).format('MM/DD/YYYY'),
        },
        {
          field: 'updatedAt',
          headerName: handleValidateCodevalue(internationalise, 'COMMON_UPDATED_AT'),
          type: 'date',
          minWidth: whocolumnWidth,
          flex: 1,
          editable: false,
          valueGetter: ({ value }) => value && moment(value).format('MM/DD/YYYY'),
        },
        
        // {
        //   field: 'created',
        //   headerName: 'Created At',
        //   type: 'date',
        //   flex: 1,
        //   editable: false,
        //   valueGetter: ({ value }) => value && moment(value).format('MM/DD/YYYY'),
        // },
        // {
        //   field: 'updated',
        //   type: 'date',
        //   headerName: 'Updated At',
        //   flex: 1,
        //   editable: false,
        //   valueGetter: ({ value }) => value && moment(value).format('MM/DD/YYYY'),
        // },
    ];
  
  const handleOnChange = (event) => {
    dispatch(setSearch(searchEntity?.template, {
      ...templateSearch,
      [event.target.name]: event.target.value,
    }));
  };
    
    const leadSearchBox = {
        ...templateSearch,
    }

    const handleResetSearch = () => {
    dispatch(
          resetSearch(searchEntity?.template,resetState(templateSearch)
        )
      );
    }
  return (
    <BiztantuLoader open={isLoadingprogress} isChildren={true}>
              <Box className="template-index-container">
        <StyledConfigurationContainer>
              <Typography variant='h6' >
              { handleValidateCodevalue(internationalise,'TEMP_SEARCH_TITLE')}
            </Typography>
              </StyledConfigurationContainer>
          <StyledIndexContainerDiv>
              <StyledLeadContainer className="template-search-panel">
                <Stack className='table-header-search table-header-search-common'>
                  <BiztantuSearch
                      showStatus = {false}
                      entityDetails = {leadSearchBox}
                      handleReset = {handleResetSearch}
                      handleSearch = {handleSearchTemplate}
                 >
                  <SearchTemplate
                  handleOnChange={handleOnChange}
                  entityDetails={templateSearch}
                  />
                  </BiztantuSearch>
                </Stack>
                <Stack className='secondry-btn-container' width="60%" padding="10px" justifyContent="flex-end" spacing={2} direction="row">
                  {specificRolePermission?.isTemplateManage &&
            <Button
              variant="outlined" className='biztantu-sec-btn'
              onClick={() => navigateTo(privateRoutesPath.CREATE_TEMPLATE,{},searchEntity?.template)}>
              { handleValidateCodevalue(internationalise,'CREATE_TEMPLATE')}
            </Button>}
                </Stack>
            </StyledLeadContainer>
          <DataGridTable 
            isCheckboxReq={false}
            dataGridData={templateData || []}
            height='calc(100vh - 270px)'
            selectionModel={selectionModel}
            isRequiredToolBar={true}
            columns={columns}
            rowModesModel={rowModesModel}
            setSelectionModel={(data) => setSelectionModel(data)}
            // handleLaunchcampaign = {handleLaunchcampaign}
            marginTop = "0px"
          />
        </StyledIndexContainerDiv>
      </Box>
        </BiztantuLoader>
  )
}

export default TemplatesTab